import Reveal from "../Reveal";
import { services } from "../../data/site";

export default function Services() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative py-24 md:py-32 border-t border-[#2E2E38] section-stripe"
    >
      <div className="max-w-[1600px] mx-auto px-6 lg:px-10">
        <Reveal>
          <div className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-10 mb-16 md:mb-24">
            <div className="md:col-span-4">
              <p className="font-['JetBrains_Mono'] text-xs uppercase tracking-[0.25em] text-[#E3FF34]">
                [ Capabilities ]
              </p>
            </div>
            <div className="md:col-span-8">
              <h2
                data-testid="services-heading"
                className="font-['Outfit'] font-medium tracking-tight text-4xl md:text-5xl lg:text-6xl text-[#F2F2F2]"
              >
                A full-service stack —{" "}
                <span className="text-[#A3A3A3]">
                  built to ship work, not decks.
                </span>
              </h2>
            </div>
          </div>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4">
          {services.map((s, i) => (
            <Reveal key={s.no} delay={i * 0.06}>
              <article
                data-testid={`service-card-${s.no}`}
                className="surface-card group relative flex flex-col justify-between p-8 lg:p-10 min-h-[300px] hover:border-[#E3FF34]/40 hover:-translate-y-1 transition-all duration-500"
              >
                <div className="flex items-start justify-between relative z-10">
                  <span className="font-['JetBrains_Mono'] text-xs uppercase tracking-[0.25em] text-[#A3A3A3]">
                    {s.no} / {String(services.length).padStart(2, "0")}
                  </span>
                  <span className="w-2 h-2 bg-[#2E2E38] group-hover:bg-[#E3FF34] group-hover:scale-150 transition-all duration-500" />
                </div>
                <div className="mt-16 relative z-10">
                  <h3 className="font-['Outfit'] text-2xl md:text-3xl text-[#F2F2F2] tracking-tight">
                    {s.title}
                  </h3>
                  <p className="mt-4 font-['Outfit'] font-light text-[#A3A3A3] text-base leading-relaxed">
                    {s.desc}
                  </p>
                  <ul className="mt-6 flex flex-wrap gap-2">
                    {s.bullets.map((b) => (
                      <li
                        key={b}
                        className="font-['JetBrains_Mono'] text-[10px] uppercase tracking-[0.2em] text-[#F2F2F2] border border-[#3A3A45] bg-[#1A1A22] px-2.5 py-1 group-hover:border-[#E3FF34]/50 group-hover:text-[#E3FF34] transition-colors"
                      >
                        {b}
                      </li>
                    ))}
                  </ul>
                </div>
                {/* hover spotlight */}
                <div
                  aria-hidden
                  className="pointer-events-none absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500"
                  style={{
                    background:
                      "radial-gradient(circle at 50% 0%, rgba(227,255,52,0.08) 0%, transparent 60%)",
                  }}
                />
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
